// --------------------------------
// --------------------------------
$(document).ready(function () {
    $(".show_hide").on("click", function () {
        var txt = $(".read-more").is(':visible') ? 'Read More' : 'Read Less';
        $(".show_hide").text(txt);
        $(this).next('.read-more').slideToggle(200);
    });

    $(".show_hide_bottom").on("click", function () {
        var txt = $(".read-more-bottom").is(':visible') ? 'Read More' : 'Read Less';
        $(".show_hide_bottom").text(txt);
        $(this).next('.read-more-bottom').slideToggle(200);
    });
});
// --------------------------------
// --------------------------------



// --------------------------------
// --------------------------------
window.addEventListener("pageshow", function (event) {
  var historyTraversal =
    event.persisted ||
    (typeof window.performance != "undefined" &&
      window.performance.navigation.type === 2);
  if (historyTraversal) {
    // Handle page restore.
    window.location.reload();
  }
});
$(function () {
  $(".button-atc").click(function () {
    //use a class, since your ID gets mangled
    $(this).addClass("button--loading"); //add the class to the clicked element
  });
});
// --------------------------------
// --------------------------------

